import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="animated fadeIn pt-3 text-center">
      <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
  );
};

export default LoadingSpinner;
